import { createGlobalStyle } from "styled-components";
import {
  lightestColor,
  primaryAccentColor,
  primaryBackgroundColor,
  primaryColor,
  primaryHeaderColor,
  primaryTextColor,
} from "../styles";

export const Styles = createGlobalStyle`
#banner-text {
  font-size: 2.5em;
  top: 500px;
}

#cc-name {
  font-size: 4.5em;
  top: 395px;
  font-family: "Garmond" !important,
  font-variant: "small-caps",
}

#banner-image {
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  --antd-wave-shadow-color: #1890ff;
  --scroll-bar: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  font-feature-settings: 'tnum', "tnum";
  font-family: 'Quicksand';
  box-sizing: border-box;
  vertical-align: middle;
  border-style: none;
  position: absolute;
  display: block;
  overflow: hidden;
  width: 100%;
  height: 500px;
  object-fit: cover;
}

@media screen and (max-width: 600px) {
  #cc-name {
    font-size: 2em;
    top: 135px;
    font-family: "Garmond" !important,
    font-variant: "small-caps",
  }
  #banner-text {
    line-height: 1em;
    font-size: 1.4em;
    padding-bottom: .45em;
    padding-top: .45em;
    top: 200px;
  }
  #banner-container {
    height: 250px;
  }
  #banner-image {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    --antd-wave-shadow-color: #1890ff;
    --scroll-bar: 0;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5715;
    font-feature-settings: 'tnum', "tnum";
    font-family: 'Quicksand';
    box-sizing: border-box;
    vertical-align: middle;
    border-style: none;
    position: absolute;
    display: block;
    overflow: hidden;
    width: 100%;
    top: -50px;
    margin-top: 2%;
    height: 300px;
    object-fit: scale-down;
  }
}
  
@media (min-width: 768px) {
  #cc-name {
    font-size: 4em;
    font-family: "Garmond" !important,
    font-variant: "small-caps",
  }
  #banner-text {
    font-size: 2.5em;
  }
}

h1 {
  font-family: "Quicksand", veranda, tahoma;
  color: ${primaryHeaderColor};
  font-weight: bold;
  font-size: 3rem;
  line-height: 1.18;

  @media only screen and (max-width: 890px) {
    font-size: 47px;
  }

  @media only screen and (max-width: 414px) {
    font-size: 32px;
  }
}

h2 {
  font-family: "Quicksand", veranda, tahoma;
  color: ${primaryHeaderColor};
  font-weight: bold;
  font-size: 3rem;
  line-height: 1.18;

  @media only screen and (max-width: 890px) {
    font-size: 47px;
  }

  @media only screen and (max-width: 414px) {
    font-size: 32px;
  }
}

h3 {
  color: ${primaryAccentColor};
}
h4 {
  font-family: "Quicksand", veranda, tahoma;
  font-weight: bold;
  font-size: 2rem;
  line-height: 1.18;
  margin-bottom: 0.75rem;

  @media only screen and (max-width: 890px) {
    font-size: 47px;
  }

  @media only screen and (max-width: 414px) {
    font-size: 32px;
  }
}

p {
  font-size: 1.25rem;
}
/*
    @font-face {
        font-family: "Quicksand", "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Quicksand", "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Quicksand", 'seasons';
        src: url(./fonts/seasons.woff2) format('woff2');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: "Quicksand", 'seasons';
        src: url(./fonts/seasons-bd.woff2) format('woff2');
        font-weight: bold;
        font-style: normal;
    }


    body,
    html,
    a {
        font-family: "Quicksand", veranda, tahoma;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: ${lightestColor};
        overflow-x: hidden;
    }

    a:hover {
        color: ${primaryTextColor};
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: ${primaryBackgroundColor};
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: ${primaryColor} 2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: "Quicksand", 'Motiva Sans Bold', serif;
        color: ${primaryTextColor};
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: ${primaryTextColor};
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }


    .services {
  max-width: 1100px;
  margin: 0 auto;
  padding: 4rem 1.5rem;
}

.services h2 {
  font-size: 2.2rem;
  font-weight: 500;
  text-align: center;
  margin-bottom: 0.75rem;
}

.services .intro {
  text-align: center;
  max-width: 640px;
  margin: 0 auto 3rem;
  color: #555;
  line-height: 1.6;
}

.servicesGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.serviceCard {
  background: #f9faf9;
  border-radius: 14px;
  padding: 2rem;
  box-shadow: 0 6px 18px rgba(0,0,0,0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  text-align: left;
}

.serviceCard h3 {
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
}

.serviceCard h4 {
  font-size: 0.95rem;
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
  color: #666;
  font-weight: 500;
}

.serviceCard p {
  line-height: 1.65;
  color: #444;
}

.serviceCard ul {
  padding-left: 1.1rem;
}


.serviceCard ul {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0;
}

.serviceCard li {
  display: grid;
  line-height: 1.5;
  grid-template-columns: 14px 1fr;
  column-gap: 10px;
  align-items: start;
  margin-bottom: 0.6rem;
}

.serviceCard li::before {
  content: "•";
  font-size: 1rem;
  line-height: 1.4;
  color: currentColor;
}
  */
`;
